<template>
  <div
    class="app-buttons"
    :class="{
      row: (row && !column) || !column,
      column: !row && column,
      reverse,
      group,
    }"
  >
    <slot />
  </div>
</template>

<script>
import { equal } from '@/helpers'

export default {
  name: 'AppButtons',

  props: {
    value: {
      required: false,
    },

    reverse: {
      type: Boolean,
      default: false,
    },

    group: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    row() {
      return [true, 'true', ''].includes(this.$attrs.row)
    },

    column() {
      return [true, 'true', ''].includes(this.$attrs.column)
    },

    hasVModel() {
      return this.$listeners.input !== undefined
    },
  },

  watch: {
    value: {
      immediate: true,
      async handler(value) {
        if (value === undefined) return

        await this.$nextTick()

        if (this.$el) {
          this.$el.parentElement
            .querySelectorAll('.active')
            .forEach(element => element.classList.remove('active'))
        }

        const targetChild = this.$children.find(child => {
          const childValue = child.value ?? child.$attrs.value

          return equal(value, childValue)
        })

        if (targetChild) targetChild.$el.classList.add('active')
      },
    },
  },

  mounted() {
    if (this.group === true && this.hasVModel === true) {
      this.$children.forEach(child => {
        const value = child.value ?? child.$attrs.value

        child.$on('click', () => this.$emit('input', value))
      })
    }
  },
}
</script>

<style lang="scss" scoped>
@use 'sass:math';

@import '@/styles/settings.scss';
@import '@/styles/functions.scss';

.app-buttons {
  display: flex;
  flex: 1;
  gap: 0.5rem;

  &.row {
    flex-direction: row;

    &.reverse {
      flex-direction: row-reverse;
    }
  }

  &.column {
    flex-direction: column;
    width: 100%;

    &.reverse {
      flex-direction: column-reverse;
    }
  }

  &.group {
    flex-wrap: nowrap;

    > .app-button {
      $radius: math.div($defaultBorderRadius, 2);
      border-radius: 0;
      margin: 0;
      border-left: 1px solid rgba(0, 0, 0, 0.05);

      &:first-child {
        border-top-left-radius: $radius;
        border-bottom-left-radius: $radius;
        border-left: 0;
      }

      &:last-child {
        border-top-right-radius: $radius;
        border-bottom-right-radius: $radius;
      }

      &.active {
        $color: $primaryColor;
        background-color: $color;
        color: get-text-color($color);
      }
    }
  }
}
</style>
